module.exports = __webpack_public_path__ + "img/director.ed9498c9.jpg";